import { FormEditor } from './form-editor.base.model';
import { File } from '../files/files.model';
import { Entity } from '../entities/entity.model';

export class Contained extends FormEditor<Array<any>> {
  controlType = 'contained';
  file: File;
  entity: any;
  entityMultilang: any;
  entityMultilangKey: string;
  fileMultilang: any;
  fileMultilangKey: string;
  isHalf: boolean;
  imgOnly: boolean;
  upload: boolean;
  mimeType: string;

  constructor(options: {} = {}) {
    super(options);
    this.file = options['file'] || null;
    this.entity = options['entity'] || null;
    this.isHalf = (typeof options['isHalf'] !== 'undefined' ? options['isHalf'] : true);
    this.imgOnly = (typeof options['imgOnly'] !== 'undefined' ? options['imgOnly'] : true);
    this.upload = (typeof options['upload'] !== 'undefined' ? options['upload'] : true);
    this.entityMultilang = options['entityMultilang'] || null;
    this.entityMultilangKey = options['entityMultilangKey'];
    this.mimeType = options['mimeType'] || null;
  }
}
